import { render, staticRenderFns } from "./UpdateRegion.vue?vue&type=template&id=aa83091c&scoped=true&"
import script from "./UpdateRegion.vue?vue&type=script&lang=js&"
export * from "./UpdateRegion.vue?vue&type=script&lang=js&"
import style0 from "./UpdateRegion.vue?vue&type=style&index=0&id=aa83091c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa83091c",
  null
  
)

export default component.exports